/** RFC 7807 problem document. Every portal-backend error response uses this shape. */
export interface ProblemDetails {
  readonly type?: string;
  readonly title?: string;
  readonly status?: number;
  readonly detail?: string;
  readonly instance?: string;
  readonly errors?: Readonly<Record<string, readonly string[]>>;
}

/** A request rejected by the API, carrying the problem document when the server supplied one. */
export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number | undefined,
    readonly problem: ProblemDetails | undefined,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
